module.exports = __webpack_public_path__ + "assets/images/branch/cases/i1.png";